/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isCount: false,
    getCountId: false, // TODO@PONY no need this way
    aggreAgreement: false,
    showError: false,
    ListOutputFields: [],
    SelectCols: [],
    UserPriceList: { // TODO@PONY fix
      PriceListId: 1
    },
    CalculatePriceMethod: 0
  },
  getters: {
    showError: state => {
      return state.showError
    },
    breakdown: state => {
      if (state.Breakdown) {
        return state.Breakdown
      } else {
        return {
          BreakdownUrl: '',
          Exists: false,
          Visible: false
        }
      }
    },
    rewardsPoint: (state, getters, rootState) => {
      /// Caculate rewards point, refer to sl/selectRestult.js ,line 494
      let order = rootState.order
      let point = 0
      if (state.HasRewardsPoint && state.RewardsFromDollar !== 0 && state.RewardsToPoint !== 0) {
        point = order.TotalEstmCost / state.RewardsFromDollar * state.RewardsToPoint
      }
      if (order.PromotionPointType !== undefined && order.PromotionPointValue > 0) {
        if (order.PromotionPointType === 4) { // entity.enums.PromotionType.XNUMBER_OF_POINT
          order.PromotionPoint = point * order.PromotionPointValue - point
          point = point * order.PromotionPointValue
        } else if (order.PromotionPointType === 5) { // entity.enums.PromotionType.NUMBER_OF_POINT
          order.PromotionPoint = order.PromotionPointValue
          point = point + state.PromotionPointValue
        }
      }

      return parseInt(point)
    },
    bonusPoint: (state, getters, rootState) => {
      let order = rootState.order
      if (order.PromotionAmount > 0) {
        return parseInt((order.TotalEstmCost + order.PromotionAmount) / state.RewardsFromDollar * state.RewardsToPoint)
      } else {
        return 0
      }
    },
    showBreakDown: (state, getters, rootState, rootGetters) => {
      return (state.Breakdown &&
        state.Breakdown.Exists &&
        !rootGetters['order/currentGeoType'].hideTwoDimension &&
        rootState.site.IsDemoBreakdownEnabled
        // !rootGetters['config/datasource'].noDemoSelect &&
        // !rootGetters['order/isAllHoseholds']
      )
    },
    showTwoDimensional: (state, getters, rootState, rootGetters) => {
      return (state.Breakdown &&
        state.Breakdown.Exists &&
        !rootGetters['order/currentGeoType'].hideTwoDimension
        // !rootGetters['config/datasource'].noDemoSelect &&
        // !rootGetters['order/isAllHoseholds']
      )
    }
  },
  mutations: {
    saveAggreAgreement (state, val) {
      state.aggreAgreement = val
    },
    saveShowError (state, val) {
      state.showError = val
    },
    saveSummary (state, values) {
      for (let key of Object.keys(values)) {
        Vue.set(state, key, values[key])
      }
    },
    saveListOutputFields (state, val) {
      state.ListOutputFields = val
    },
    saveSelectedCols (state, item) {
      let col = {
        text: '',
        value: '',
        disabled: false
      }

      for (let key of Object.keys(item)) {
        if (col.hasOwnProperty(key)) {
          col[key] = item[key]
        }
      }

      for (let key of Object.keys(state.SelectCols)) {
        if (state.SelectCols[key].value === col.value) {
          return
        }
      }
      state.SelectCols.push(col)
    },
    deleteCols (state, item) {
      for (let i in state.SelectCols) {
        if (state.SelectCols[i].value === item) {
          Vue.delete(state.SelectCols, i)
        }
      }
    },
    clearCols (state, item) {
      let cols = []
      for (let i in state.SelectCols) {
        if (state.SelectCols[i].disabled) {
          cols.push(state.SelectCols[i])
        }
      }
      state.SelectCols = cols
    },
    saveKey (state, val) {
      Vue.set(state, val[0], val[1])
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/summary/index.js